import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failureGetScheduleSetupData,
    successGetScheduleSetupData
} from "./ScheduleSetupDataSlice";

// API call to fetch schedule setup data
const GetScheduleSetupDataApi = (subjectId: number) => {
    return api.get(`/api/schedule-class/setup-data?subject_id=${subjectId}`);
};

// Saga to handle fetching schedule setup data
export function* ScheduleSetupDataCall(action: PayloadAction<number>) {
    try {
        const response: AxiosResponse = yield call(GetScheduleSetupDataApi, action.payload);
        if (response.data.status) {
            yield put(successGetScheduleSetupData(response.data));
        } else {
            yield put(failureGetScheduleSetupData(response.data.message));
        }
    } catch (error: any) {
        yield put(failureGetScheduleSetupData(error.response?.data || error.message));
    }
}
